import { ClientState } from './types';

const state = (): ClientState => {
  return {
    clients: [],
  };
};

export default state;
